import React from 'react'

export const FilledWishlistIcon = () => {
    return (
        <svg
            id="add_to_wishlist_-_icon"
            data-name="add to wishlist - icon"
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 40 40"
            role="img"
            aria-label="wishlist-icon"
        >
            <g className="fav_-_on" data-name="fav - on">
                <g className="frame" fill="#fff" stroke="transparent" strokeWidth="1.5">
                    <rect width="40" height="40" stroke="none"></rect>
                    <rect x="0.75" y="0.75" width="38.5" height="38.5" fill="none"></rect>
                </g>
                <g className="fav" transform="translate(-662.113 -1007.42)">
                    <path
                        className="wish"
                        d="M24.737,47.088a6.2,6.2,0,0,0-.72-1.6,6.5,6.5,0,0,0-6.829-2.815,6.437,6.437,0,0,0-4.75,4.377A6.439,6.439,0,0,0,.865,45.486a6.054,6.054,0,0,0-.725,1.6,8.548,8.548,0,0,0,0,3.682A9.365,9.365,0,0,0,1.1,53.136c1.41,2.465,3.715,4.308,5.894,6.083,0,0,.01.01.015.01a32.641,32.641,0,0,0,2.945,2.124c.835.537,1.665,1.07,2.485,1.627.815-.557,1.65-1.094,2.485-1.627a33.64,33.64,0,0,0,2.945-2.124s.01-.01.015-.01c2.18-1.77,4.485-3.618,5.894-6.083a9.553,9.553,0,0,0,.965-2.366A8.707,8.707,0,0,0,24.737,47.088Z"
                        transform="translate(669.676 975.669)"
                        fill="#FF640A"
                        stroke="#FF640A"
                        strokeWidth="1.5"
                    ></path>
                </g>
            </g>
        </svg>
    )
}

export default FilledWishlistIcon
